import Brand from '@ovpn/ui/brand';

import { boxed } from '@sso/shared/hocs';

export default boxed(Brand);
